<template>
  <b-container fluid class="bg-white shadow px-3 pb-5 px-6-lg pb-2-lg w-lg-70">
    <h2 class="py-3">Activity Details</h2>
    <b-form>
      <ValidationObserver ref="observer" slim>
        <b-card>
          <b-form-row>
            <h5 class="col-12 text-primary font-weight-bold pb-2">Harvest Activities</h5>
          </b-form-row>
          <HarvestDetailsForm
            v-if="harvestExists"
            :harvestDetails="activityDetails.harvestDetails"
            :isLUPCTown="isLUPCTown"
          />
          <span class="font-sm" v-else>
            No Harvest Activities were indicated for this Notification on the Mapping page. Please
            go back to the Mapping page to add Harvest Activity areas if there will be harvesting as
            part of this Operation.
          </span>
        </b-card>
        <b-card>
          <b-form-row>
            <h5 class="col-12 text-primary font-weight-bold pb-2">Road Construction Activities</h5>
          </b-form-row>
          <RoadDetailsForm
            v-if="roadExists && isLUPCTown"
            :roadDetails="activityDetails.roadDetails"
          />
          <span class="font-sm" v-else-if="roadExists && !isLUPCTown">
            You indicated you will be constructing road(s) as part of this Operation.
            Please review road construction requirements on the Summary page.
          </span>
          <span class="font-sm" v-else>
            No Road Construction Activities were indicated for this Notification on the Mapping
            page. Please go back to the Mapping page to add Road Construction Activities if there
            will be road construction as part of this Operation.
          </span>
        </b-card>
        <b-card>
          <b-form-row>
            <h5 class="col-12 text-primary font-weight-bold pb-2">Water Crossing Activities</h5>
          </b-form-row>
          <span class="font-sm" v-if="waterCrossingExists">
            You indicated you will be constructing water crossing(s) as part of this Operation.
            Please review water crossing requirements on the Summary page.
          </span>
          <span class="font-sm" v-else>
            No Water Crossing Activities were indicated for this Notification on the Mapping page.
            Please go back to the Mapping page to add Water Crossing Activities if you will be
            constructing water crossing(s) as part of this Operation.
          </span>
        </b-card>
      </ValidationObserver>
    </b-form>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import FormSubmit from '@/mixins/FormSubmit';
import HarvestDetailsForm from './HarvestDetailsForm.vue';
import RoadDetailsForm from './RoadDetailsForm.vue';

export default {
  name: 'ActivityDetailsForm',
  components: {
    HarvestDetailsForm,
    RoadDetailsForm,
  },
  mixins: [FormSubmit],
  props: {
    notificationId: {
      type: Number,
    },
    initialActivityDetails: {
      type: Object,
    },
    isLUPCTown: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    const activityDetails = {
      id: null,
      notificationId: this.notificationId,
      harvestDetails: {
        totalHarvestArea: null,
        taxLaw: null,
        landUseChange: null,
        landUseChangeCategoryId: null,
        landUseChangeArea: null,
        clearcut20: null,
        clearcut75: null,
        waterFeature: null,
        woodToStream: null,
        sws250ComplianceTypeId: null,
        sws75ComplianceTypeId: null,
      },
      roadDetails: {
        alterationArea: null,
        discontinueDate: null,
        femaFloodZone: null,
      },
    };
    if (this.initialActivityDetails) {
      activityDetails.id = this.initialActivityDetails.id;
      if (this.initialActivityDetails.harvestDetails) {
        Object.assign(activityDetails.harvestDetails, this.initialActivityDetails.harvestDetails);
      }
      if (this.initialActivityDetails.roadDetails) {
        Object.assign(activityDetails.roadDetails, this.initialActivityDetails.roadDetails);
      }
    }
    return {
      activityDetails,
    };
  },
  computed: {
    ...mapGetters('Activity', ['harvestExists', 'roadExists', 'waterCrossingExists']),
    ...mapGetters('User', ['mfsAdmin']),
  },
  watch: {
    notificationId(value) {
      this.activityDetails.notificationId = value;
    },
  },
  methods: {
    async submitWrapper() {
      if (this.mfsAdmin) {
        return true;
      }
      const submitDto = {
        ...this.activityDetails,
        harvestDetails: this.harvestExists ? this.activityDetails.harvestDetails : null,
        roadDetails: this.roadExists && this.isLUPCTown
          ? this.activityDetails.roadDetails
          : null,
      };
      return this.submit(
        this.$refs.observer,
        this.activityDetails.id ? 'ActivityDetails/update' : 'ActivityDetails/create',
        submitDto,
      );
    },
    async load() {
      this.$store.dispatch('ActivityDetails/fetch');
      this.$store.dispatch('ActivityDetails/fetchRequirements');
    },
  },
};
</script>
